<div *ngIf="!openHoldForm">
    <div class="Tabletitle">
        <span> Hold Groups ({{holdsCount}}) </span>
    </div>

    <div class="row">
        <button mat-raised-button class="actionButton m-1" (click)="createHold($event)">Create Hold</button>
        <div class="input-group-sm mt-2 input-group col-6">
            <input *ngIf="tableData" class="form-control" type="search" (keyup)="applyFilter($event)" placeholder="Filter">
        </div>
    </div>

    <div *ngIf="!tableData && noHolds">
        No Hold groups to display.
    </div>

    <div *ngIf="tableData" class="table-container mat-elevation-z8">
        <table mat-table matSort [dataSource]="tableData" matSortActive="name" matSortDirection="asc" aria-describedby="holds-table">

            <!--- Note that these columns can be defined in any order.
              The actual rendered columns are set as a property on the row definition"
      -->

            <!-- Hold Name Column -->
            <ng-container matColumnDef="name">
                <th id="name" mat-header-cell *matHeaderCellDef mat-sort-header> Name </th>
                <td mat-cell *matCellDef="let hold"> {{hold.name}} </td>
            </ng-container>

            <!-- Description Column -->
            <ng-container matColumnDef="description">
                <th id="description" mat-header-cell *matHeaderCellDef mat-sort-header> Description </th>
                <td mat-cell *matCellDef="let hold"> {{hold.description}} </td>
            </ng-container>

            <!-- Date Created Column -->
            <ng-container matColumnDef="datecreated">
                <th id="date" mat-header-cell *matHeaderCellDef mat-sort-header> Date Created </th>
                <td mat-cell *matCellDef="let hold"> {{hold.create_date | date}} </td>
            </ng-container>

            <!-- Created By Column -->
            <ng-container matColumnDef="created_by">
                <th id="createdBy" mat-header-cell *matHeaderCellDef mat-sort-header> Created By </th>
                <td mat-cell *matCellDef="let hold"> {{hold.created_by}} </td>
            </ng-container>

            <!-- Date Updated Column -->
            <ng-container matColumnDef="dateupdated">
                <th id="dateUpdated" mat-header-cell *matHeaderCellDef mat-sort-header> Date Updated </th>
                <td mat-cell *matCellDef="let hold"> {{hold.modified_date | date}} </td>
            </ng-container>

            <!-- Updated By Column -->
            <ng-container matColumnDef="modified_by">
                <th id="updatedBy" mat-header-cell *matHeaderCellDef mat-sort-header> Updated By </th>
                <td mat-cell *matCellDef="let hold"> {{hold.modified_by}} </td>
            </ng-container>

            <!-- Active Column -->
            <ng-container matColumnDef="active">
                <th id="active" *matHeaderCellDef class="mat-header-sortless"> Active </th>
                <td mat-cell *matCellDef="let hold">
                    <mat-icon *ngIf="hold.active">check</mat-icon>
                </td>
            </ng-container>

            <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>

            <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>

        </table>
        <mat-paginator [pageSizeOptions]="[10, 20, 50]" showFirstLastButtons></mat-paginator>
    </div>
</div>


<div *ngIf="openHoldForm">
    <div class="sticky-top">
        <div class="Tabletitle">{{dialogData.title}}</div>
    </div>
    <div *ngIf=!createdHold>
        <form #initiateForm="ngForm">
            <div class="card-body">
                <div class="input-group-sm mb-3 input-group col-12">
                    <div class="input-group-prepend">
                        <span class="input-group-text form-label-105">Name</span>
                    </div>
                    <input name="name" class="form-control" type="text" [(ngModel)]="dialogData.name" required>
                </div>

                <div class="input-group-sm mb-3 input-group col-12">
                    <div class="input-group-prepend">
                        <span class="input-group-text form-label-105">Description</span>
                    </div>
                    <textarea name="description" class="form-control" type="text" [(ngModel)]="dialogData.description" required></textarea>
                </div>

                <div style="float: right;">
                    <button mat-raised-button *ngIf="dialogData.button=='Create'" class="actionButton m-3" (click)="createHoldButton()" [disabled]="!initiateForm.valid">{{dialogData.button}}</button>
                    <button mat-raised-button *ngIf="dialogData.button=='Update'" class="actionButton m-3" (click)="updateHoldButton()" [disabled]="!initiateForm.valid">{{dialogData.button}}</button>
                    <button mat-raised-button class="backButton m-2" (click)="back()">Back</button>
                </div>
            </div>
        </form>
    </div>
    <div class="card mt-5" *ngIf="createdHold">
        <div class="card-body">

            <div>Hold Group <strong>{{dialogData.name}} </strong>has been created.</div>
            <button class="button-class" style="margin: 1em;" mat-raised-button (click)="back()">Back</button>

        </div>
    </div>
</div>